import { PropsWithChildren } from 'react';

import PageSectionContainer from '../PageSectionContainer';

const ImageSection = ({ content }: PropsWithChildren<any>) => {
  return (
    <PageSectionContainer className="section__image">
      <figure style={{ margin: 0 }}>
        <img src={content.url} alt={content.alt ?? ''} style={{ maxWidth: '100%' }} />
        {content.title && <figcaption>{content.title}</figcaption>}
      </figure>
    </PageSectionContainer>
  );
};

export default ImageSection;
